import { useCallback } from 'react';
import { type UpdateQueryParameterValues } from './use-update-query-parameter-values';

interface UseCloseVehicleDetailProperties {
  readonly updateQueryParameterValues: UpdateQueryParameterValues;
}

const useCloseVehicleDetail = ({ updateQueryParameterValues }: UseCloseVehicleDetailProperties): (() => void) =>
  useCallback(() => {
    updateQueryParameterValues({
      filterKeys: { chassisNumber: [] },
    });
  }, [updateQueryParameterValues]);

export default useCloseVehicleDetail;
